export default function (list) {
  const [list1, list2, list3] = list

  switch (list.length) {
    case 0:
      return []
    case 1:
      return [list1, list1, list1, list1, list1]
    case 2:
      return [list1, list2, list1, list2, list1, list2]
    case 3:
      return [list1, list2, list3, list1, list2, list3]
    default:
      return list
  }
}
